

































































import Vue from 'vue';
import Component from 'vue-class-component';
import {
  challengeModule,
  galleryModule,
  galleryState
} from '@/utils/store-acessor';
import { ChallengeModel } from '@/models/challenge.model';
import { GalleryModel } from '@/models/gallery.model';
import { bottomVisible } from '@/utils/utils';
import { Emit, Watch } from 'vue-property-decorator';

@Component({})
export default class ChallengeDetailGallery extends Vue {
  index = null;
  page = 1;

  @challengeModule.Getter('selectedChallenge')
  challenge!: ChallengeModel | null;
  @galleryModule.Getter('gallery') gallery!: GalleryModel[];
  @galleryModule.Getter('lastPage') lastPage!: number;
  @galleryModule.Getter('loading') loading!: boolean;

  async mounted() {
    if (this.challenge?.id) {
      await galleryState.fetchGallery({
        challengeId: this.challenge.id,
        params: {
          page: 1
        }
      });
    }
  }

  imagesPathToArray(): string[] {
    return this.gallery.map(data => data.image_url);
  }

  @Watch('page')
  onPageChange(value: number) {
    if (this.challenge?.id) {
      galleryState.fetchGallery({
        challengeId: this.challenge.id,
        params: {
          page: value
        }
      });
    }
  }
}
